import React, { useCallback, useEffect, useRef } from 'react';
import QuickPinchZoom, { make3dTransformValue } from 'react-quick-pinch-zoom';
import { getImageStyle } from '../../../../../common/atoms/DamImage/DamImage.styles';
import { StyledPinchZoomImage } from '../../styles/PinchZoomImage.styles';

const PinchZoomImage = ({
  imgSrc,
  alt,
  imgData,
  className,
  primaryBrand,
  tabIndex,
  onLoad,
  isProductImage,
  lazyLoadImage,
  selectedPDPImage,
  isPDP,
  fromQv,
}) => {
  const imageRef = useRef();
  const quickPinchZoomRef = useRef();

  const onUpdate = useCallback(
    ({ x, y, scale }) => {
      const { current: img } = imageRef;

      if (img && img.complete) {
        const value = make3dTransformValue({ x, y, scale });
        img.style.setProperty('transform', value);
        img.style.opacity = 1;
      } else if (img) {
        const value = make3dTransformValue({ x: 0, y: 0, scale: 1 });
        img.style.setProperty('transform', value);
        img.style.opacity = 0;
      }
    },
    [imgSrc]
  );

  const resetZoom = () => {
    const { current: img } = imageRef;
    const { current: quickPinchZoomElement } = quickPinchZoomRef;
    if (img && img.complete) {
      const { width, height } = img;

      const centerX = width / 2;
      const centerY = height / 2;

      quickPinchZoomElement.alignCenter({ x: centerX, y: centerY, scale: 1 });
    }
  };

  useEffect(
    () =>
      function cleanup() {
        resetZoom();
      }
  );

  return (
    <QuickPinchZoom
      onUpdate={onUpdate}
      draggableUnZoomed={false}
      shouldInterceptWheel={() => false}
      doubleTapZoomOutOnMaxScale={true}
      ref={quickPinchZoomRef}
    >
      <StyledPinchZoomImage
        fwdRef={imageRef}
        src={imgSrc.url}
        crop={imgSrc.crop}
        altText={alt}
        overrideStyle={getImageStyle(imgData)}
        className={className}
        primaryBrand={primaryBrand}
        tabIndex={tabIndex}
        onLoad={onLoad}
        backgroundStyle={imgData.backGroundStyle}
        isProductImage={isProductImage}
        lazyLoadImage={lazyLoadImage}
        selectedPDPImage={selectedPDPImage}
        pinchZoomImagePage={true}
        isPDP={isPDP}
        fromQv={fromQv}
      />
    </QuickPinchZoom>
  );
};

export default PinchZoomImage;
